import { Drawer, Input, Tree } from "antd"
import { IAccountDetail } from "../../../../api/groupPermission/groupPermissionApi"
import { useEffect, useState } from "react"
import * as fomartUnit from "../../../../services/fomartUnit"
import * as SelectOptionApi from "../../../../api/selectOptions/selectOptionsApi"
import *as unitApi from "../../../../api/unit/unitApi"
import { CaretDownOutlined } from "@ant-design/icons"
import Item from "antd/es/list/Item"
interface DrawerProps {
  isOpen: boolean
  infoAccount?: IAccountDetail
  closeDrawer: () => void

}
const DrawerInfoAccount: React.FC<DrawerProps> = ({
  isOpen, infoAccount,
  closeDrawer
}) => {
  const [valuesTagUnit, setValuesTagUnit] = useState<number[]>([]);
  useEffect(() => {
    if (isOpen) {
      const listTagUnitTmg = infoAccount?.unitsByPermissionGroup
        ?.flatMap((item) => item.units.map((children) => children?.id))

      setValuesTagUnit(listTagUnitTmg || [])
    }
  }, [isOpen])
  return (
    <Drawer
      title={<p className="font-medium fw-500 text-344054 py-3 px-6 bg-FCFCFD">Thông tin người dùng</p>}
      placement="right"
      rootClassName="custom-drawer-v2"
      closable={false}
      onClose={closeDrawer}
      open={isOpen}
      footer={[]}
    >
      <div className="d-flex flex-column ">
        <p className="text-sm fw-700 font-bold text-344054 py-4">Thông tin cơ bản</p>
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Mã nhân viên</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.code}</p>
          </div>
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Họ và tên</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.fullname}</p>
          </div>
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6"> Tên đăng nhập</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.email}</p>
          </div>
        </div>
        <p className="text-sm fw-700 font-bold text-344054 py-5">Quyền và nhóm quyền</p>
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Toàn quốc</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.region}</p>
          </div>
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Đơn vị</p>
            <p className=" text-sm  font-regular text-475467">
              {infoAccount?.unit?.title}
              <span className={`text-BBBBBC ${infoAccount?.unit?.code === undefined && "none"}`}>{`(${infoAccount?.unit?.code})`}</span>
            </p>
          </div>
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Khối nghiệp vụ</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.businessUnit}</p>
          </div>
          <div className="d-flex align-center">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Phòng ban</p>
            <p className=" text-sm  font-regular text-475467">{infoAccount?.department}</p>
          </div>
          <div className="d-flex ">
            <p className="w-120-px text-sm fw-500 font-medium text-475467 mr-6">Nhóm quyền</p>
            <div className="d-flex flex-column">
              {(infoAccount?.groupPermission && infoAccount?.groupPermission?.length > 0) ? infoAccount.groupPermission.map((item, i) =>
                <p key={i} className=" text-sm  font-regular text-475467">{item}</p>
              )

                : ''
              }


            </div>

          </div>
        </div>
        <p className="text-sm fw-700 font-bold text-344054 py-5">Phạm vi áp dụng</p>
        <div className='pt-3 d-flex justify-between align-center gap-3'>
          <Tree
            checkable
            showLine={true}
            switcherIcon={<CaretDownOutlined className=' text-8E8E8E' />}
            checkedKeys={valuesTagUnit}
            treeData={unitApi.convertNationwideTreeV2(infoAccount?.permissionGroupsByUnit || [])}
            className="custom-ant-tree"
          />
        </div>
      </div>
    </Drawer>
  )
}
export default DrawerInfoAccount
